<template>
    <div id="more-detail">
        <h2>{{ $t("fastWizard.tellUsMore") }}</h2>
        <div class="row">
            <div class="col">
                <md-field>
                    <label>Website</label>
                    <md-input v-model="website"></md-input>
                    <span class="md-helper-text">{{ $t("fastWizard.websiteIntegration") }}</span>
                </md-field>
            </div>
            <div class="col">
                <md-field
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                        zIndex: 99999999999999,
                    }"
                    :class="{
                        'md-invalid': errors.first($t('message.preferredLanguage')) != null,
                    }"
                    :content="$t('fastWizard.vtippyPreferredLanguage')"
                >
                    <label>{{ $t("message.preferredLanguage") }}</label>
                    <md-select
                        v-model="preferredLanguage"
                        v-validate="'required|included:en,tr,ru'"
                        :name="`${$t('message.preferredLanguage')}`"
                        autocomplete="off"
                    >
                        <md-option>{{ $t("message.selectALanguage") }}</md-option>
                        <md-option v-for="lang in languages" :key="lang.code" :value="lang.code"
                            >{{ langLabels[lang.code][$i18n.locale] }}
                        </md-option>
                    </md-select>
                    <span class="md-error w-100">{{ errors.first($t("message.preferredLanguage")) }}</span>
                </md-field>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col">
                <md-field :class="{ 'md-invalid': errors.first($t('message.rootUserName')) != null }">
                    <label>{{ $t("message.rootUserName") }}</label>
                    <md-input
                        id="organizationName"
                        v-model="userName"
                        v-validate="'required'"
                        :name="$t('message.rootUserName')"
                        :placeholder="$t('message.rootUserName')"
                        autocomplete="off"
                        type="text"
                    ></md-input>
                    <span class="md-error">{{ errors.first($t("message.rootUserName")) }}</span>
                </md-field>
            </div>
            <div class="col">
                <md-field :class="{ 'md-invalid': errors.first($t('message.organizationName')) != null }">
                    <label>{{ $t("message.organizationName") }}</label>
                    <md-input
                        id="organizationName"
                        v-model="organizationName"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        v-validate="'required'"
                        :content="$t('message.vtipyOrganizationName')"
                        :name="$t('message.organizationName')"
                        :placeholder="$t('message.organizationName')"
                        autocomplete="off"
                        type="text"
                    ></md-input>
                    <span class="md-error">{{ errors.first($t("message.organizationName")) }}</span>
                </md-field>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { createScreenshot } from "../../api/screenshot";
import { sendSocketMessage } from "../../utils/socketStream";
import log2 from "../../utils/log2";
import moment from "moment";
import { getNavigatorLanguage } from "../../utils/language";
import * as _ from "lodash";

const log = log2("MoreDetail");
export default {
    name: "MoreDetail",
    data() {
        return {
            website: null,
            preferredLanguage: getNavigatorLanguage().code,
            langLabels: {
                tr: {
                    tr: "Türkçe(Turkish)",
                    en: "Turkish",
                    ru: "турецкий(Turkish)",
                    de: "Türkisch(Turkish)",
                    fr: "Turc(Turkish)",
                    es: "Turco(Turkish)",
                    ar: "اللغة التركية(Turkish)",
                    it: "Turco(Turkish)",
                },
                en: {
                    tr: "İngilizce(English)",
                    en: "English",
                    ru: "английский(English)",
                    de: "Türkisch(English)",
                    fr: "Anglais(English)",
                    es: "Inglés(English)",
                    ar: "إنجليزي(English)",
                    it: "Inglese(English)",
                },
                ru: {
                    tr: "Rusça(Russian)",
                    en: "Russian",
                    ru: "русский(Russian)",
                    de: "Russisch(Russian)",
                    fr: "Russe(Russian)",
                    es: "Ruso(Russian)",
                    ar: "الروسية(Russian)",
                    it: "Russo(Russian)",
                },
                de: {
                    tr: "Almanca(German)",
                    en: "German",
                    ru: "русский(German)",
                    de: "Deutsch(German)",
                    fr: "Allemand(German)",
                    es: "Alemán(German)",
                    ar: "ألمانية(German)",
                    it: "Tedesco(German)",
                },
                fr: {
                    tr: "Fransızca(French)",
                    en: "French",
                    ru: "русский(French)",
                    de: "Französisch(French)",
                    fr: "Français(French)",
                    es: "Francés(French)",
                    ar: "فرنسي(French)",
                    it: "Francese(French)",
                },
                es: {
                    tr: "İspanyolca(Spanish)",
                    en: "Spanish",
                    ru: "русский(Spanish)",
                    de: "Spanisch(Spanish)",
                    fr: "Espagnol(Spanish)",
                    es: "Español(Spanish)",
                    ar: "الأسبانية(Spanish)",
                    it: "Spagnolo(Spanish)",
                },
                ar: {
                    tr: "Arapça(Arabic)",
                    en: "Arabic",
                    ru: "русский(Arabic)",
                    de: "Arabisch(Arabic)",
                    fr: "Arabe(Arabic)",
                    es: "Arábica(Arabic)",
                    ar: "عربي(Arabic)",
                    it: "Arabo(Arabic)",
                },
                it: {
                    tr: "İtalyanca(Italian)",
                    en: "Italian",
                    ru: "русский(Italian)",
                    de: "Italienisch(Italian)",
                    fr: "Italien(Italian)",
                    es: "Italiano(Italian)",
                    ar: "الإيطالية(Italian)",
                    it: "Italiano(Italian)",
                },
            },
        };
    },
    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
            user: (state) => _.cloneDeep(state.auth.user),
            languages: (state) => state.language.languages,
        }),
        organizationName: {
            get() {
                return this.settings.organizationName;
            },
            async set(value) {
                this.changeOrganizationName((value || "").trim());
            },
        },
        userName: {
            get() {
                if (!this.user) return "-";
                return _.get(this.user, "name");
            },
            async set(value) {
                this.changeUserName(value);
            },
        },
    },
    methods: {
        ...mapActions({
            getSettings: "setting/getSettings",
            updateSettings: "setting/updateSettings",
            setSettingValue: "setting/setSettingValue",
            setLanguage: "language/setLanguage",
            updateUser: "user/updateUser",
        }),
        applySettings(newSettings) {
            this.updateSettings(newSettings).then(() => {
                sendSocketMessage("user settings-updated", {
                    siteId: this.site._id,
                });
            });
        },
        changeWebsite: _.debounce(async function (website) {
            if (this.settings.website === website) return;
            createScreenshot(website);
            const newSettings = await this.setSettingValue({
                setting: "website",
                value: website,
            });

            this.applySettings(newSettings);
        }, 1000),
        changeOrganizationName: _.debounce(async function (value) {
            const newSettings = await this.setSettingValue({
                setting: "organizationName",
                value,
            });

            this.applySettings(newSettings);
        }, 1000),
        changeUserName: _.debounce(async function (value) {
            const result = this.updateUser({ ...this.user, name: value.trim() });
            result.then(() => {
                this.$toasted.show(this.$t("message.userSaved"), {
                    duration: 3000,
                    position: "bottom-center",
                });
                sendSocketMessage("user user-updated", {
                    userId: this.user._id,
                    siteId: this.site._id,
                });
            });
        }, 1000),
    },
    mounted() {
        log("preferredLanguage changed");
        if (this.settings && this.settings.website) {
            this.website = this.settings.website;
        }
    },
    watch: {
        settings: {
            handler: function (newSettings) {
                if (newSettings.website !== this.website) {
                    this.website = newSettings.website;
                }
                if (newSettings.language.customerClientDefault !== this.preferredLanguage) {
                    this.preferredLanguage = newSettings.language.customerClientDefault;
                }
            },
            deep: true,
        },
        async website(newWebsite) {
            if (newWebsite && newWebsite.length) {
                if (newWebsite !== this.settings.website) {
                    this.changeWebsite(newWebsite);
                }
            }
        },
        async preferredLanguage(lang) {
            if (lang) {
                log("preferredLanguage changed", lang);
                let newSettings = await this.setSettingValue([
                    { setting: "language.clientDefault", value: lang },
                    { setting: "language.customerClientDefault", value: lang },
                ]);
                await this.applySettings(newSettings);
                await this.setLanguage(lang);
                this.$i18n.locale = lang;
                if (moment.locale() !== lang) moment.locale(lang);
            }
        },
    },
};
</script>

<style scoped></style>
